// eslint-disable-next-line no-restricted-imports
import { ClientsListItemFragment } from 'api/generated/graphql';
import { ClientsListItemData } from 'api/types/data';

import { parseClientOnboardingData } from '../client/parseClientOnboardingData';
import { parseClientAccountStatus } from '../client/parseEntity/parseClientAccountStatus';
import { parseClientOnboardingStatus } from '../client/parseEntity/parseClientOnboardingStatus';
import { parseCountryEntity } from '../parseCountryEntity';

export const parseClientsListItemData = (
  clients: ClientsListItemFragment[]
): ClientsListItemData[] =>
  clients.map((client) => ({
    id: client.id,
    firstName: client.firstName,
    lastName: client.lastName,
    middleName: client.middleName ?? undefined,
    email: client.email ?? undefined,
    phone: client.phoneNumber ?? undefined,

    citizenship: client.citizenships?.[0]
      ? parseCountryEntity(client.citizenships[0])
      : undefined,

    code: client.code ?? undefined,
    centralDepositoryAccountNumber:
      client.centralDepositoryAccountNumber ?? undefined,
    personalAccountNumber: client.personalAccount?.number ?? undefined,
    personalAccountOpeningDate: client.personalAccount?.openingDate
      ? new Date(client.personalAccount.openingDate)
      : undefined,

    onboardingStatus: parseClientOnboardingStatus(client.onboardingStatus),
    accountStatus: parseClientAccountStatus(client.accountStatus),

    countryRegistration: client.registrationAddress?.country.name,
    location: client.residentialAddress?.country.name,

    onboarding: parseClientOnboardingData(client),

    lastSessionDate: client.user.lastAuthSessionLog?.updatedAt
      ? new Date(client.user.lastAuthSessionLog?.updatedAt)
      : undefined,

    representative: client.representative?.user.lastAuthSessionLog?.updatedAt
      ? {
          lastSessionDate: new Date(
            client.representative.user.lastAuthSessionLog?.updatedAt
          ),
        }
      : undefined,
  }));
